import * as THREE from 'three';
import { animateRingFlash } from './ui/animator.js';

export function updateEnemyStatusEffects(game, dt) {
  for (const enemy of game.enemies) {
    if (!enemy?.alive) continue;
    if (enemy._bleedTime > 0) {
      enemy._bleedTime = Math.max(0, enemy._bleedTime - dt);
      enemy._bleedTick = (enemy._bleedTick || 0) + dt;
      if (enemy._bleedTick >= 1) {
        enemy._bleedTick = 0;
        enemy.takeDamage(enemy._bleedDps || 0, game);
      }
    }
  }
}

export function updateBurstShots(game, dt) {
  for (let i = game._pendingBurstShots.length - 1; i >= 0; i--) {
    const shot = game._pendingBurstShots[i];
    shot.t -= dt;
    if (shot.t > 0) continue;
    shot.cb();
    game._pendingBurstShots.splice(i, 1);
  }
}

export function flashCircle(game, x, z, r) {
  const geo = new THREE.RingGeometry(r * 0.2, r, 24);
  const mat = new THREE.MeshBasicMaterial({
    color: 0xff7a33,
    transparent: true,
    opacity: 0.8,
    side: THREE.DoubleSide,
  });
  const ring = new THREE.Mesh(geo, mat);
  ring.rotation.x = -Math.PI / 2;
  ring.position.set(x, 0.05, z);
  game.scene.add(ring);
  animateRingFlash(ring, mat);
}

export function worldToScreen(game, x, y, z) {
  game._hitFxTmpV.set(x, y, z).project(game.cameraRig.camera);
  if (game._hitFxTmpV.z < -1 || game._hitFxTmpV.z > 1) return null;
  return {
    x: (game._hitFxTmpV.x * 0.5 + 0.5) * window.innerWidth,
    y: (-game._hitFxTmpV.y * 0.5 + 0.5) * window.innerHeight,
  };
}

export function toast(game, msg) {
  game.hud.toast(msg);
}

export function schedulePlayerBurstShot(game, delay, cb) {
  if (typeof cb !== 'function') return;
  game._pendingBurstShots.push({ t: Math.max(0, delay), cb });
}

export function spawnPlayerMine(game, x, z, opts = {}) {
  const geo = new THREE.CylinderGeometry(0.24, 0.3, 0.22, 8);
  const mat = new THREE.MeshStandardMaterial({
    color: 0xff9944,
    emissive: 0xff6a22,
    emissiveIntensity: 0.6,
    roughness: 0.45,
    metalness: 0.35,
  });
  const mesh = new THREE.Mesh(geo, mat);
  mesh.position.set(x, 0.12, z);
  mesh.castShadow = true;
  game.scene.add(mesh);
  game.playerMines.push({
    mesh,
    x,
    z,
    damage: opts.damage ?? 2,
    radius: opts.radius ?? 2.6,
    triggerRadius: opts.triggerRadius ?? 1.3,
    life: opts.maxLifetime ?? 10,
    sourceWeaponId: opts.sourceWeaponId ?? 'bakuha_mines',
    armedAt: 0.25,
    t: 0,
  });
}


